"use client";

import { createContext, use } from "react";

export const IconSwapContext = createContext<{ value?: string }>({});

export const useIconSwapContext = () => use(IconSwapContext);
